import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HotelI18n_HotelInfoSettingsPage_Query } from "./query";

type Props = {
	hotelID: string;
	langCode: LangCode;
};

export const useHotelInfoI18nQuery = ({ hotelID, langCode }: Props) => {
	const { data } = useCustomSuspenseQuery(HotelI18n_HotelInfoSettingsPage_Query, {
		variables: {
			hotelID,
			lang: langCode,
		},
	});

	return {
		data,
	};
};
